import { AppThunk } from "../states/generateStore";
import snackBarSlice from '../states/snackbar/slice';
import { getDataLead, suiteCrmUrl } from "./constants";
import shellSlice from '../states/shell/slice';
import { decode } from 'html-entities';

const onGetDataLead = (leadId: any): AppThunk =>
  async (dispatch, getStore) => {
    try {
      let formData = new FormData();
      formData.append('record_id', leadId);

      let response = await fetch(suiteCrmUrl.concat(getDataLead),
        { 
          method: 'POST',
          body: formData
        }
      );
      let result = await response.json();

      if (result) {
        // convert to Lead state
        dispatch(shellSlice.actions.updateLeadId(result.id[1]));

        // description Lead
        let description = result.description[1];
        // let info_pack   = result.issendinfopack_c[1].indexOf('daikin') !== -1 ? "no" : "yes";
        let note_select = "", customer_note = "";

        if ( description ) {
          // customer note
          if (description.hasOwnProperty("Messages")) {
            note_select = "yes";
            customer_note = description["Messages"];
          }
        }
        
        // initial form value
        let initialValuePayload = getStore().shell.initialValues;
        initialValuePayload = {
          ...initialValuePayload,
          address: decode(result.billing_address_street[1]),
          full_address: decode(result.address[1]),
          locality: decode(result.billing_address_city[1]),
          state: decode(result.billing_address_state[1]),
          zip: decode(result.billing_address_postalcode[1]),
          your_email: decode(result.billing_account_email[1]),
          first_name: decode(result.first_name[1]),
          last_name: decode(result.last_name[1]),
          phone_number: result.mobile_phone_c[1],
          hear_about: decode(result.lead_source[1]),
          note_select: decode(note_select),
          customer_note: decode(customer_note),
          // info_pack: info_pack,
        }
        dispatch(shellSlice.actions.updateInitialValues(initialValuePayload));

        // set useDataLead = true
        dispatch(shellSlice.actions.updateUseDataLead(true));

        // show success
        dispatch(snackBarSlice.actions.updateAlert({message: "Get data Lead success", severity: "success"}));
        dispatch(snackBarSlice.actions.updateSnackBar(true));
      } else {
        // show warning
        dispatch(snackBarSlice.actions.updateAlert({message: "Unable to get Lead data", severity: "warning"}));
        dispatch(snackBarSlice.actions.updateSnackBar(true));
      }
    } catch (err) {
      console.log(err);
      // show error
      dispatch(snackBarSlice.actions.updateAlert({message: "onGetDataLead: Can not get data from Server", severity: "error"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }
  }

export default onGetDataLead;